import { render, staticRenderFns } from "./AddSizeModal.vue?vue&type=template&id=8afdb1ae"
import script from "./AddSizeModal.vue?vue&type=script&lang=js"
export * from "./AddSizeModal.vue?vue&type=script&lang=js"
import style0 from "./AddSizeModal.vue?vue&type=style&index=0&id=8afdb1ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports